import type { ParsedUrlQuery } from 'querystring';

export const hasSkuInQuery = (query: ParsedUrlQuery): query is ParsedUrlQuery & { sku: string } =>
	typeof query.sku === 'string' && query.sku.length > 0;

export const skuFromQuery = (query: ParsedUrlQuery): string =>
	hasSkuInQuery(query) ? query.sku : 'sleep.sub.70.y.t1w';
